import * as React from 'react';
import Popover from '@mui/material/Popover';
import './fullScreenPopup.scss';
import LogTable from '../logTable';

export default function PopOver() {
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'log-summary-popover' : undefined;

    return (
        <div className='center-div'>
            <span className="playPauseTags" style={{cursor: 'pointer'}} onClick={handleClick}>View Report</span>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <LogTable />
            </Popover>
        </div>
    );
}
